import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";
import {
  setLoading,
  setProvider,
  setProviderReviews,
} from "../../redux/slices/providerSlice";

export const fetchProviderDetails = async (dispatch, providerId) => {
  dispatch(setLoading(true));
  try {
    const response = await getApiCaller(
      `provider_details?provider_id=${providerId}`
    );
    dispatch(setProvider(response.data.response_data));
    dispatch(setProviderReviews(response.data.response_data.review_list));
  } catch (error) {
    toast.error("Failed to fetch provider details.");
  } finally {
    dispatch(setLoading(false));
  }
};
